// Pfad: src/pages/ApplicantCV2_SoftSkills.jsx
// Zweck/Funktion: Submodul für Soft‑Skills (CV_common) inkl. Hobbies. Einheitliche Typo, gruppierte Slider, stabile Defaults.

import React from "react";
import { Label } from "../components/ui/label";
import { Input } from "../components/ui/input";
import { Separator } from "../components/ui/separator";

export const SOFT_SKILL_KEYS = [
  "Zuverlaessigkeit_Puenktlichkeit",
  "Motivation_Eigeninitiative",
  "Zeitmanagement",
  "Anpassungsfaehigkeit_Resilienz",
  "Kritisches_Denken",
  "Innovationsfaehigkeit",
  "Strategisches_Denken",
  "Schnelle_Auffassungsgabe",
  "Technologien_Prozesse",
  "Feedback",
  "Klare_Ausdrucksweise",
  "Aktives_Zuhoren",
  "Praesentationstechniken",
  "Konfliktmanagement",
  "Empathie_interkulturelle_Kompetenz",
  "Netzwerken_Beziehungsmanagement",
  "Entscheidungsfaehigkeit",
  "Delegieren_Motivation",
  "Coaching_Mentoring",
  "Agilitaet_Anpassungsfaehigkeit",
  "Digitale_Kompetenz_Medienaffinitaet",
  "Sensibilitaet_Diversity",
  "Unternehmerisches_Denken",
];

const LABELS = {
  Zuverlaessigkeit_Puenktlichkeit: "Zuverlässigkeit & Pünktlichkeit",
  Motivation_Eigeninitiative: "Motivation & Eigeninitiative",
  Zeitmanagement: "Zeitmanagement",
  Anpassungsfaehigkeit_Resilienz: "Anpassungsfähigkeit & Resilienz",
  Kritisches_Denken: "Kritisches Denken",
  Innovationsfaehigkeit: "Innovationsfähigkeit",
  Strategisches_Denken: "Strategisches Denken",
  Schnelle_Auffassungsgabe: "Schnelle Auffassungsgabe",
  Technologien_Prozesse: "Technologien & Prozesse",
  Feedback: "Feedback‑Kultur",
  Klare_Ausdrucksweise: "Klare Ausdrucksweise",
  Aktives_Zuhoren: "Aktives Zuhören",
  Praesentationstechniken: "Präsentationstechniken",
  Konfliktmanagement: "Konfliktmanagement",
  Empathie_interkulturelle_Kompetenz: "Empathie & interkulturelle Kompetenz",
  Netzwerken_Beziehungsmanagement: "Netzwerken & Beziehungsmanagement",
  Entscheidungsfaehigkeit: "Entscheidungsfähigkeit",
  Delegieren_Motivation: "Delegieren & Motivation",
  Coaching_Mentoring: "Coaching & Mentoring",
  Agilitaet_Anpassungsfaehigkeit: "Agilität & Anpassungsfähigkeit",
  Digitale_Kompetenz_Medienaffinitaet: "Digitale Kompetenz & Medienaffinität",
  Sensibilitaet_Diversity: "Sensibilität für Diversity",
  Unternehmerisches_Denken: "Unternehmerisches Denken",
};

export function ensureCommonInit(common) {
  const base = { marriage_status: "", marriage_childs: 0, skill_hobbies: "", ...common };
  SOFT_SKILL_KEYS.forEach((k) => {
    if (typeof base[k] !== "number") base[k] = 0;
  });
  return base;
}

function SkillSlider({ value, onChange }) {
  return (
    <input
      type="range"
      min={0}
      max={5}
      step={1}
      value={typeof value === "number" ? value : 0}
      onChange={(e) => onChange(Number(e.target.value))}
      className="w-full"
      aria-label="Soft-Skill-Wert"
    />
  );
}

const SoftSkillsSection = ({ common, onChange }) => {
  const update = (key, val) => onChange({ ...(common || {}), [key]: val });

  const Group = ({ title, keys }) => (
    <section className="applicant-workspace-subcard applicant-workspace-subcard--softskills">
      <h4>{title}</h4>
      <div className="space-y-4">
        {keys.map((k) => (
          <div key={k} className="applicant-softskill-row">
            <Label className="applicant-workspace-label">{LABELS[k] || k}</Label>
            <div className="applicant-softskill-row__control">
              <SkillSlider value={common?.[k]} onChange={(v) => update(k, v)} />
              <span className="applicant-softskill-row__value">{common?.[k] ?? 0}/5</span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );

  return (
    <div className="space-y-6">
      <Group
        title="Selbstorganisation & Denken"
        keys={[
          "Zuverlaessigkeit_Puenktlichkeit", "Motivation_Eigeninitiative", "Zeitmanagement",
          "Anpassungsfaehigkeit_Resilienz", "Kritisches_Denken", "Innovationsfaehigkeit",
          "Strategisches_Denken", "Schnelle_Auffassungsgabe",
        ]}
      />
      <Group
        title="Kommunikation"
        keys={[
          "Feedback", "Klare_Ausdrucksweise", "Aktives_Zuhoren", "Praesentationstechniken",
          "Konfliktmanagement", "Empathie_interkulturelle_Kompetenz", "Netzwerken_Beziehungsmanagement",
        ]}
      />
      <Group title="Führung & Zusammenarbeit" keys={["Entscheidungsfaehigkeit", "Delegieren_Motivation", "Coaching_Mentoring"]} />
      <Group
        title="Agilität & Digitales"
        keys={[
          "Agilitaet_Anpassungsfaehigkeit", "Digitale_Kompetenz_Medienaffinitaet", "Sensibilitaet_Diversity",
          "Unternehmerisches_Denken", "Technologien_Prozesse",
        ]}
      />

      <Separator className="applicant-softskill-separator" />

      <section className="applicant-workspace-subcard applicant-workspace-subcard--softskills">
        <h4>Hobbies / Interessen</h4>
        <div>
          <Input
            placeholder="z. B. Ehrenamt, Sport, Musik, Community‑Engagement…"
            value={common?.skill_hobbies || ""}
            onChange={(e) => update("skill_hobbies", e.target.value)}
            className="applicant-field"
          />
        </div>
      </section>
    </div>
  );
};

export default SoftSkillsSection;
